export enum TenantBillingEventLogStatusEnum {
	PENDING = 'pending',
	SYNCED = 'synced',
}
